import { render, staticRenderFns } from "./InspectionFormVehicleStep.vue?vue&type=template&id=b7af526c&scoped=true"
import script from "./InspectionFormVehicleStep.vue?vue&type=script&lang=js"
export * from "./InspectionFormVehicleStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7af526c",
  null
  
)

export default component.exports